var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('div',{staticClass:"mt-2 min-h-57"},[_c('h2',[_vm._v("Resultado Fundamentos Econômico-Financeiro")]),(_vm.selectedTable && _vm.selectedTable.title)?_c('FundoTable',{attrs:{"hide_table":"","data":{
        indicators: _vm.selectedTable.indicators,
        total: _vm.selectedTable.total,
      }}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }